import { h, Component } from 'preact'
import { GA4EVENT } from '../../calendar-common/constants'

class Dropdown extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isOpen: false
        }

        this.onOptionClick = this.onOptionClick.bind(this)
    }

    onOptionClick(value) {
        this.setState({ isOpen: false })
        this.props.onOptionSelected(value)
    }

    render({
        values,
        selectedValue,
        renderTitle,
        renderOption,
        containerClass = '',
        titleClass = '',
        optionsContainerClass = '',
        optionClass = '',
        optionButtonSizeClass = 'fxs_btn_xsmall',
        getButtonGtmId,
        getButtonGa4Id,
        getOptionGtmId,
        getOptionGa4Id,
        getGa4Name
    },
        {
            isOpen
        }) {
        return (
            <div class={`fxs_selectable-wrapper ${containerClass}`}
                onMouseLeave={() => this.setState({ isOpen: false })}>

                <button
                    type="button"
                    class={`fxs_selectable-trigger  ${titleClass}`}
                    onClick={() => this.setState({ isOpen: !isOpen })}
                    data-gtmid={getButtonGtmId && getButtonGtmId()}
                    data-ga4event-clk-name={getGa4Name && getGa4Name}
                    data-ga4event-element={getButtonGa4Id && getButtonGa4Id()}
                >
                    {renderTitle(selectedValue, isOpen)}
                </button>

                {isOpen &&
                    <div class={`fxs_options-box ${optionsContainerClass}`}>
                        {
                            values.map((option) => {
                                return (<button
                                    type="button"
                                    class={`fxs_btn fxs_btn_phantom ${optionButtonSizeClass} fxs_selectable-option ${optionClass}`}
                                    onClick={() => this.onOptionClick(option)}
                                    data-gtmid={getOptionGtmId && getOptionGtmId(option)}
                                    data-ga4event-clk-name={getGa4Name && getGa4Name}
                                    data-ga4event-element={getOptionGa4Id && getOptionGa4Id(option)}
                                >
                                    {renderOption(option)}
                                </button>)
                            })}
                    </div>
                }
            </div>
        )
    }
}
export default Dropdown
